import { Appointments, Plage } from "cadendar-shared";
import { functionnal } from "vincent-utils";
const isRdvBeforeHour = (rdv: Appointments, hourInMinutes: number) =>
  rdv.hour * 60 + rdv.minute + rdv.duration <= hourInMinutes;
const isRdvAfterHour = (rdv: Appointments, hourInMinutes: number) =>
  rdv.hour * 60 + rdv.minute >= hourInMinutes;
const filterAfter = (heureEnMinutes: number) => {
  "use strict";
  return (rdvs: Appointments[]) =>
    rdvs.filter(functionnal.curry2(isRdvAfterHour)(heureEnMinutes));
};
const filterBefore = (heureEnMinutes: number) => {
  "use strict";
  return (rdvs: Appointments[]) =>
    rdvs.filter(functionnal.curry2(isRdvBeforeHour)(heureEnMinutes));
};
const rdvsFromPlage = (rdvsDuJour: Appointments[], plage: Plage) => {
  const plageStart = plage.start.hour * 60 + plage.start.minute;
  const plageEnd = plage.end.hour * 60 + plage.end.minute;
  // return _.compose(filterAfter(plageStart), filterBefore(plageEnd))(rdvsDuJour);
  return filterAfter(plageStart)(filterBefore(plageEnd)(rdvsDuJour));
};
export default rdvsFromPlage;
